<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Mfa',
  components: {},
  data() {
    return {}
  },
  methods: {}
}
</script>
